import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../utils/networkHandler";
export const tokenConfig = (getState) => {
  const token = getState().auth.accessToken;

  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  if (token) {
    config.headers["Authorization"] = `Bearer ${token}`;
  }
  return config;
};

//Get Top Board
export const getTopBoard = createAsyncThunk(
  "report/getTopBoard",
  async (_, { getState, rejectWithValue }) => {
    try {
      const config = tokenConfig(getState);
      const response = await axios.get(`/admin/report-top-board`, config);
      return response.data;
    } catch (error) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

//Get Performance Analytics
//Monthly
export const getAnalytics = createAsyncThunk(
  "board/getPerformanceAnalytics",
  async (_, { getState, rejectWithValue }) => {
    try {
      const config = tokenConfig(getState);
      const response = await axios.get(`/admin/analytics`, config);
      return response.data;
    } catch (error) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

//Daily

//Hourly
export const getDailyAnalytics = createAsyncThunk(
  "board/getDailyAnalytics",
  async ({startDate, endDate, singleDay}, { getState, rejectWithValue }) => {
    try {
      const config = tokenConfig(getState);
      const params = [];
      if (startDate) {
        params.push(`startDate=${encodeURIComponent(startDate)}`);
      }
      if (endDate) {
        params.push(`endDate=${encodeURIComponent(endDate)}`);
      }
      if (singleDay) {
        params.push(`singleDay=${encodeURIComponent(singleDay)}`);
      }
      
      const response = await axios.get(`/admin/analytics/conversions?${params.join("&")}`, config);
      return response.data;
    } catch (error) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

//** Campaign **//
//Get Top Campaigns
export const getTopCampaigns = createAsyncThunk(
  "report/getTopCampaigns",
  async (
    { page, rowsPerPage, startDate, endDate, exportData, search},
    { getState, rejectWithValue }
  ) => {
    try {
      const config = tokenConfig(getState);
      const params = [];
      if (page !== undefined && rowsPerPage !== undefined) {
        params.push(`page=${page + 1}`, `limit=${rowsPerPage}`);
      }
      if (startDate) {
        params.push(`startDate=${encodeURIComponent(startDate)}`);
      }
      if (endDate) {
        params.push(`endDate=${encodeURIComponent(endDate)}`);
      }
      if (exportData) {
        params.push(`exportData=true`, `exportType=csv`);
      }
      if (search) {
        params.push(`search=${encodeURIComponent(search)}`);
      }
      const response = await axios.get(`/admin/top-campaigns?${params.join("&")}`, config);
      return response.data;
    } catch (error) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);
//Get Campaign Details
export const getCampaignDetails = createAsyncThunk(
  "report/getCampaignDetails",
  async ({page, rowsPerPage, startDate, endDate, campaignReference}, { getState, rejectWithValue }) => {
    try {
      const config = tokenConfig(getState);
      let params = `page=${page + 1}&limit=${rowsPerPage}`;
      if (startDate) {
          params += `&startDate=${encodeURIComponent(startDate)}`;
        }
        if (endDate) {
            params += `&endDate=${encodeURIComponent(endDate)}`;
          }
      const response = await axios.get(`/admin/campaign-notifications-daily/${campaignReference}?${params}`, config);
      return response.data;
    } catch (error) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);
//Get Campaign Publishers
export const getCampaignPublishers = createAsyncThunk(
  "report/getPublisher",
  async (
    { page, rowsPerPage, startDate, endDate, campaignReference, exportData},
    { getState, rejectWithValue }
  ) => {
    try {
      const config = tokenConfig(getState);
      const params = [];
      if (page !== undefined && rowsPerPage !== undefined) {
        params.push(`page=${page + 1}`, `limit=${rowsPerPage}`);
      }
      if (startDate) {
        params.push(`startDate=${encodeURIComponent(startDate)}`);
      }
      if (endDate) {
        params.push(`endDate=${encodeURIComponent(endDate)}`);
      }
      if (exportData) {
        params.push(`exportData=true`, `exportType=csv`);
      }
      const response = await axios.get(`/admin/campaign-publisher/${campaignReference}?${params.join("&")}`, config);
      return response.data;
    } catch (error) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);
//Export Campaign Details
export const exportCampaignDetails = createAsyncThunk(
  "report/exportCampaignDetails",
  async ({startDate, endDate, campaignReference}, { getState, rejectWithValue }) => {
    try {
      const config = tokenConfig(getState);
      let params = 'exportData=true&exportType=csv';
      if (startDate) {
        params += `&startDate=${encodeURIComponent(startDate)}`;
      }
      if (endDate) {
        params += `&endDate=${encodeURIComponent(endDate)}`;
      }
      const response = await axios.get(`/admin/campaign-notifications-daily/${campaignReference}?${params}`, config);
      return response.data;
    } catch (error) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

//** Publisher **//
//Get Top Publishers
export const getTopPublishers = createAsyncThunk(
    "report/publisher",
    async (
      { page, rowsPerPage, startDate, endDate, exportData, search},
      { getState, rejectWithValue }
    ) => {
      try {
        const config = tokenConfig(getState);
        const params = []
        if (page !== undefined && rowsPerPage !== undefined) {
          params.push(`page=${page + 1}`, `limit=${rowsPerPage}`);
        }
        if (startDate) {
          params.push(`startDate=${encodeURIComponent(startDate)}`);
        }
        if (endDate) {
          params.push(`endDate=${encodeURIComponent(endDate)}`);
        }
        if (exportData) {
          params.push(`exportData=true`, `exportType=csv`);
        }
        if (search) {
          params.push(`search=${encodeURIComponent(search)}`);
        }
        const response = await axios.get(`/admin/top-publishers?${params.join("&")}`, config);
        return response.data;
      } catch (error) {
        if (!error.response) {
          throw error;
        }
        return rejectWithValue(error.response.data);
      }
    }
  );
  //Get Publisher Campaigns
  export const getPublisherCampaigns = createAsyncThunk(
    "report/getCampaigns",
    async (
      { page, rowsPerPage, startDate, endDate, publisherReference, exportData},
      { getState, rejectWithValue }
    ) => {
      try {
        const config = tokenConfig(getState);
        const params = [];
      if (page !== undefined && rowsPerPage !== undefined) {
        params.push(`page=${page + 1}`, `limit=${rowsPerPage}`);
      }
      if (startDate) {
        params.push(`startDate=${encodeURIComponent(startDate)}`);
      }
      if (endDate) {
        params.push(`endDate=${encodeURIComponent(endDate)}`);
      }
      if (exportData) {
        params.push(`exportData=true`, `exportType=csv`);
      }
        const response = await axios.get(`/admin/publisher-campaign/${publisherReference}?${params.join("&")}`, config);
        return response.data;
      } catch (error) {
        if (!error.response) {
          throw error;
        }
        return rejectWithValue(error.response.data);
      }
    }
  );
  //Get Publisher Details
  export const getPublisherDetails = createAsyncThunk(
    "report/getPublisherDetails",
    async ({page, rowsPerPage, startDate, endDate, publisherReference}, { getState, rejectWithValue }) => {
      try {
        const config = tokenConfig(getState);
        let params = `page=${page + 1}&limit=${rowsPerPage}`;
        if (startDate) {
            params += `&startDate=${encodeURIComponent(startDate)}`;
          }
          if (endDate) {
              params += `&endDate=${encodeURIComponent(endDate)}`;
            }
        const response = await axios.get(`/admin/publisher-notifications-daily/${publisherReference}?${params}`, config);
        return response.data;
      } catch (error) {
        if (!error.response) {
          throw error;
        }
        return rejectWithValue(error.response.data);
      }
    }
  );
  //Export Publisher Details
  export const exportPublisherDetails = createAsyncThunk(
    "report/exportPublisherDetails",
    async ({startDate, endDate, publisherReference}, { getState, rejectWithValue }) => {
      try {
        const config = tokenConfig(getState);
        let params = 'exportData=true&exportType=csv';
        if (startDate) {
          params += `&startDate=${encodeURIComponent(startDate)}`;
        }
        if (endDate) {
          params += `&endDate=${encodeURIComponent(endDate)}`;
        }
        const response = await axios.get(`/admin/publisher-notifications-daily/${publisherReference}?${params}`, config);
        return response.data;
      } catch (error) {
        if (!error.response) {
          throw error;
        }
        return rejectWithValue(error.response.data);
      }
    }
  );

const reportSlice = createSlice({
  name: "report",
  initialState: {
    topBoard: {},
    analytics: [],
    dailyAnalytics: [],
    topCampaigns: [],
    topPublishers: [],
    campaignPublishers: [],
    publisherCampaigns: [],
    campaignDetails: [],
    publisherDetails: [],
    loading: false,
    error: null,
    meta: null,
    metaP: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // get-top-board
      .addCase(getTopBoard.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getTopBoard.fulfilled, (state, action) => {
        state.topBoard = action.payload.data;
        state.loading = false;
      })
      .addCase(getTopBoard.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      })
      // get-analytics
      .addCase(getAnalytics.pending, (state) => {
        state.loading = true
        })
        .addCase(getAnalytics.fulfilled, (state, action) => {
          state.analytics = action.payload.data;
          state.loading = false;
        })
        .addCase(getAnalytics.rejected, (state, action) => {
          state.error = action.payload;
          state.loading = false;
      })
      // get-daily-analytics
      .addCase(getDailyAnalytics.pending, (state) => {
        state.loading = true
        })
        .addCase(getDailyAnalytics.fulfilled, (state, action) => {
          state.dailyAnalytics = action.payload.data;
          state.loading = false;
        })
        .addCase(getDailyAnalytics.rejected, (state, action) => {
          state.error = action.payload;
          state.loading = false;
      })
      // get-top-campaigns
      .addCase(getTopCampaigns.pending, (state, action) => {
        const { exportData } = action.meta.arg || {};
        if (exportData) {
          state.loading = false;
          return;
        }
        state.loading = true;
      })
      .addCase(getTopCampaigns.fulfilled, (state, action) => {
        const { exportData } = action.meta.arg || {};
        if (exportData) {
          state.loading = false;
          return;
        }
        state.topCampaigns = action.payload.data || [];
        state.meta = action.payload.meta; // Store pagination meta
        state.loading = false;
      })
      .addCase(getTopCampaigns.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      })
      // get-top-publishers
      .addCase(getTopPublishers.pending, (state, action) => {
        const { exportData } = action.meta.arg || {};
        if (exportData) {
          state.loading = false;
          return;
        }
        state.loading = true;
      })
      .addCase(getTopPublishers.fulfilled, (state, action) => {
        const { exportData } = action.meta.arg || {};
        if (exportData) {
          state.loading = false;
          return;
        }
        state.topPublishers = action.payload.data;
        state.metaP = action.payload.meta; // Store pagination meta
        state.loading = false;
      })
      .addCase(getTopPublishers.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      })
      // get-campaign-publishers
      .addCase(getCampaignPublishers.pending, (state, action) => {
        const { exportData } = action.meta.arg || {};
        if (exportData) {
          state.loading = false;
          return;
        }
        state.loading = true;
      })
      .addCase(getCampaignPublishers.fulfilled, (state, action) => {
        const { exportData } = action.meta.arg || {};
        if (exportData) {
          state.loading = false;
          return;
        }
        state.campaignPublishers = action.payload.data || [];
        state.meta = action.payload.meta; // Store pagination meta
        state.loading = false;
      })
      .addCase(getCampaignPublishers.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      })
      // get-publisher-campaigns
      .addCase(getPublisherCampaigns.pending, (state, action) => {
        const { exportData } = action.meta.arg || {};
        if (exportData) {
          state.loading = false;
          return;
        }
        state.loading = true;
      })
      .addCase(getPublisherCampaigns.fulfilled, (state, action) => {
        const { exportData } = action.meta.arg || {};
        if (exportData) {
          state.loading = false;
          return;
        }
        state.publisherCampaigns = action.payload.data || [];
        state.meta = action.payload.meta; // Store pagination meta
        state.loading = false;
      })
      .addCase(getPublisherCampaigns.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      })
      // get-campaign-details
      .addCase(getCampaignDetails.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCampaignDetails.fulfilled, (state, action) => {
        state.campaignDetails = action.payload.data;
        state.meta = action.payload.meta; // Store pagination meta
        state.loading = false;
      })
      .addCase(getCampaignDetails.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      })
      // get-publisher-details
      .addCase(getPublisherDetails.pending, (state) => {
        state.loading = true;
      })
      .addCase(getPublisherDetails.fulfilled, (state, action) => {
        state.publisherDetails = action.payload.data;
        state.meta = action.payload.meta; // Store pagination meta
        state.loading = false;
      })
      .addCase(getPublisherDetails.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      })
  },
});

export default reportSlice.reducer;
